import React from 'react';

const HelpDialogue = () => {
  return (
    <div className="email-support-link text-left pull-right">
      <ul>
        <li className="help-label">
          <b>Need help in filling out this form?</b>
        </li>
        <li>
          <ol>
            <li>
              <b>AMEX&nbsp;Colleagues: </b>
              <span>
                <a
                  href="https://square.americanexpress.com/docs/DOC-25818"
                  target="_blank"
                  rel="noreferrer"
                >
                  Click Here
                </a>
              </span>
            </li>
            <li>
              <b>Vendors: </b>
              <span>
                Reach out to your Amex point of contact. Alternatively you can
                also write to us at{' '}
                <a href="mailto:amexp2psupplierqueries@aexp.com">
                  amexp2psupplierqueries@aexp.com
                </a>
              </span>
            </li>
          </ol>
        </li>
      </ul>
    </div>
  );
};
export default HelpDialogue;
